<template>
  <div class="page">
    <nav-bar />
    <search-bar />

    <div class style="width: 100vw;">
      <div class="page-content">
        <div class="p10">我的上下级</div>

        <div class="fc jc ac p30">
          <div class="member-info p20 fr ac">
            <img
              :src="sub_member_info.member_img"
              style="width: 60px;height: 60px;border-radius: 50%"
            />
            <div class="ml20">
              <div>{{sub_member_info.member_nick_name}}</div>
              <div class="mt20">{{sub_member_info.member_account}}</div>
            </div>
          </div>
        </div>

        <!--        他的下级-->
        <div style="width: 920px;margin: 20px auto">
          <el-tabs v-model="tab" type="card">
            <el-tab-pane :label="`Ta的下级（${sub_company_list.length})`" name="1">
              <div class="member-list mb50">
                <div
                  class="item fr ac p20"
                  style="border-bottom: 1px solid #f5f5f5"
                  v-for="(item,index) in  sub_company_list"
                  :key="index"
                >
                  <img :src="item.member_img" style="width: 40px;height: 40px;border-radius: 50%" />

                  <div class="ml20">
                    <div>{{item.member_nick_name}}</div>
                    <div class="mt10 grey">{{item.member_account}}</div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane :label="`Ta的客户（${sub_member_list.length}）`" name="2">
              <div class="company-list mb50">
                <div class="item fr ac" v-for="(item,index) in sub_member_list" :key="index">
                  <img :src="item.company_logo" style="width: 80px;height: 80px" alt />
                  <div class="ml20">
                    <div>{{item.company_name}}</div>
                    <div class="mt20">{{item.company_tel}}</div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>

    <footer-bar />
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import SearchBar from "@/components/SearchBar";
import FooterBar from "@/components/FooterBar";

export default {
  props: {},
  data() {
    return {
      sub_member_info: "",
      tab: "1",
      //  下级详情的下级
      sub_member_list: [],
      //下级详情的下级客户 company
      sub_company_list: []
    };
  },
  watch: {
    $route(n) {
      let param = this.$route.query;
      this.sub_member_info = JSON.parse(param.sub_member_info);
      this.getSubMemberList();
      this.getSubCompanyList();
    }
  },
  mounted() {
    let param = this.$route.query;
    this.sub_member_info = JSON.parse(param.sub_member_info);
    this.getSubMemberList();
    this.getSubCompanyList();
  },
  methods: {
    //  我的下下级 member
    getSubMemberList() {
      let param = {
        invite_code: this.sub_member_info.invite_code,
        parent_id: this.sub_member_info.member_id
      };
      this.post("memberInterfaces/v1.0/getSaleCompanyList", param).then(res => {
        this.sub_member_list = res.data;
      });
    },
    //  我的下下级 company
    getSubCompanyList() {
      let param = {
        parent_id: this.sub_member_info.member_id
      };
      this.post("memberInterfaces/v1.0/getSubSaleList", param).then(res => {
        this.sub_company_list = res.data;
      });
    }
  },
  components: {
    "nav-bar": NavBar,
    "search-bar": SearchBar,
    "footer-bar": FooterBar
  }
};
</script>

<style scoped lang="scss">
.page-content {
  width: 1200px;
  margin: 20px auto;
  background-color: #ffffff;
}

.member-info {
  width: 920px;
  height: 120px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.16);
  opacity: 1;
  border-radius: 4px;
}

.company-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .item {
    width: 300px;
    height: 118px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(242, 242, 242, 1);
    box-shadow: 0px 2px 4px rgba(65, 65, 65, 0.16);
    opacity: 1;
    margin-left: 20px;
    margin-top: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/me/myRelation/subDetail.vue